import { useLocation } from 'react-router-dom'
import { EXTERNAL_FILES_BASE_PATH } from '../js-helpers/constants/variables'
export function ToggleApps({ internalApp, externalApp }) {
  const loc = useLocation()
  return loc.pathname.startsWith(EXTERNAL_FILES_BASE_PATH) ? externalApp : internalApp
}